// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        d="M9 .027A9.838 9.838 0 0 0 .159 8.04c-.121.655-.146.965-.146 1.776 0 .985.073 1.598.287 2.416.738 2.82 2.569 5.083 5.148 6.365a9.762 9.762 0 0 0 6.157.867c1.544-.28 3.124-1.007 4.375-2.012l.223-.18 3.317 3.313c3.218 3.216 3.32 3.315 3.46 3.367a.757.757 0 0 0 .972-.972c-.052-.14-.151-.242-3.367-3.46-2.54-2.542-3.308-3.324-3.288-3.348.013-.018.094-.118.178-.224a9.852 9.852 0 0 0 2.071-7.416 9.972 9.972 0 0 0-1.985-4.746 9.803 9.803 0 0 0-2.921-2.52 9.886 9.886 0 0 0-3.96-1.23A13.271 13.271 0 0 0 9 .026m.42 1.488a8.206 8.206 0 0 0-3.575 1A7.601 7.601 0 0 0 4 3.886a7.733 7.733 0 0 0-1.613 2.21 8.44 8.44 0 0 0-.804 2.556c-.065.43-.09 1.41-.049 1.885.128 1.45.688 2.964 1.523 4.115a9.45 9.45 0 0 0 1.539 1.629 8.43 8.43 0 0 0 4.02 1.753c.672.099 1.602.11 2.22.027 2.012-.27 3.804-1.201 5.12-2.658 1.161-1.285 1.86-2.804 2.108-4.579.032-.228.042-.47.043-1.008 0-.72-.011-.877-.11-1.44a8.284 8.284 0 0 0-4.461-5.985 8.171 8.171 0 0 0-4.116-.876"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
};

const Search1Icon = Icon;
export default Search1Icon;
